import {
    IconActivityHeartbeat,
    IconFileText,
    IconGauge,
    IconLayoutDashboard,
    IconSettings,
} from '@tabler/icons-react';
import i18n from 'i18next';
import { NavigationData } from 'components/Navigation/NavigationPage';

export const siteNavigationData: NavigationData = {
    overview: {
        title: i18n.t('navigation:site_navigation.overview'),
        icon: ({ ...props }) => <IconLayoutDashboard {...props} />,
        link: '/site/:siteId/dashboard/overview',
    },
    performance: {
        title: i18n.t('navigation:site_navigation.performance'),
        icon: ({ ...props }) => <IconGauge {...props} />,
        link: '/site/:siteId/dashboard/performance',
    },
    diagnostics: {
        title: i18n.t('navigation:site_navigation.diagnostics'),
        icon: ({ ...props }) => <IconActivityHeartbeat {...props} />,
        link: '/site/:siteId/dashboard/diagnostics',
        hints: ['show-view-site-jobs'],
    },
    logs: {
        title: i18n.t('navigation:site_navigation.logs'),
        icon: ({ ...props }) => <IconFileText {...props} />,
        link: '/site/:siteId/dashboard/logs',
    },
    configuration: {
        title: i18n.t('navigation:site_navigation.configuration'),
        icon: ({ ...props }) => <IconSettings {...props} />,
        link: '/site/:siteId/configuration',
    },
};
